import { useContext, useEffect, useState } from 'react';
import { useLoaderData, useLocation, useNavigate } from 'react-router-dom';
import { useImmerReducer } from 'use-immer';
import PageBuilder from '../../../../library/Builders/PageBuilder/PageBuilder';
import { GlobalContext } from '../../../../library/Core/GlobalContext';
import { SmartContext } from '../../../../library/Core/SmartContext';
import smartReducer from '../../../../library/Core/SmartReducer';
import { DispatchEvent, State } from '../../../../library/Core/SmartTypes';
import { addUserSpecificDomains } from '../../../../library/Service/domainService';
import { handleCompleteLater, handleNext, onCurrentJobSelectionChange } from './EntrepreneurshipActions';
import { onPrimaryCurrentChange } from '../primaryCurrentJob';
import EntrepreneurshipLayout from './EntrepreneurshipLayout';
import ProfilePicturePageConfig from '../ProfilePicturePageConfig.json';
import CurrentJobInformationLayout from '../CurrentJobInformationLayout';

const FOUNDER_STATUS_HIDE_EXPRESSION =
    "!(model.role == 'ADMIN' && row.seniorityLevelCode == 'LEADERSHIP')";

const applyFounderStatusHideExpression = (node: any): any => {
    if (!node) return node;
    if (Array.isArray(node)) return node.map(applyFounderStatusHideExpression);
    if (typeof node !== 'object') return node;
    const next = { ...node };
    if (next.id === 'founderStatus') {
        next.hideExpression = FOUNDER_STATUS_HIDE_EXPRESSION;
    }
    if (next.controlGroup) next.controlGroup = applyFounderStatusHideExpression(next.controlGroup);
    if (next.sectionRepository) next.sectionRepository = applyFounderStatusHideExpression(next.sectionRepository);
    return next;
};

const Entrepreneurship = () => {
    const { globalState } = useContext(GlobalContext);
    const navigate = useNavigate();
    const [redirectUrl, setRedirectUrl] = useState('');

    const location = useLocation();
    const currentMatch = location.pathname.includes('current')

    const [state, dispatch] = useImmerReducer<State, DispatchEvent>(smartReducer, {
        flags: { isDataLoading: true, showFormErrors: 0 },
        formValidationErrors: {},
        actions: {
            NEXT: handleNext,
            I_LL_DO_THIS_LATER: handleCompleteLater,
            ROUTER_NAVIGATE: navigate,
            isCurrent: onCurrentJobSelectionChange,
            isPrimaryCurrent: onPrimaryCurrentChange('entreprenurship'),
            REDIRECT: setRedirectUrl
        },
    } as any);

    const { formConfig, data, routeInfo } = useLoaderData() as State;

    useEffect(() => {
        const domain = addUserSpecificDomains(new Map([...globalState.domain]), data);
        // data['entreprenurship'] = data['entreprenurship'] || {};

        // This code for Profile Picture Section from config----------
            let updatedFormConfig: any = applyFounderStatusHideExpression({ ...formConfig });
            console.log("currentMatch",currentMatch)
            if (currentMatch) {
                const rawProfileSection =
                    ProfilePicturePageConfig.sectionRepository.find(
                        (sec: any) => sec.id === "profile"
                    );
                console.log("rawProfileSection",rawProfileSection)
                if (rawProfileSection && !updatedFormConfig.sections?.includes("profile")) {
                    updatedFormConfig = {
                        ...updatedFormConfig,
                        sections: [...(updatedFormConfig.sections ?? []), "profile"],
                        sectionRepository: [
                            ...(updatedFormConfig.sectionRepository ?? []),
                            rawProfileSection as any
                        ],
                    };
                }
            }
            // end here

        const updatedEntrepreneurship = {
            ...data.entreprenurship,
            isCurrent: currentMatch ? true : data.entreprenurship?.isCurrent ?? 0,
        };
        dispatch({
            type: 'DATA_INIT',
            payload: {
                formConfig: updatedFormConfig,
                data: {
                    ...data,
                    entreprenurship: updatedEntrepreneurship,
                    currentMatch
                },
                domain,
                routeInfo,
            },
        });
    }, []);

    useEffect(() => {
        if (redirectUrl !== '') {
            navigate(redirectUrl);
        }
    }, [redirectUrl]);

    let message =   (currentMatch) ? `Since you mentioned you are currently an Entrepreneur, please provide the details.`
    : `In your work status, you mentioned that you are currently an entrepreneur. Please provide the details of your entrepreneurship.`

    const LayoutComponent = currentMatch ? CurrentJobInformationLayout : EntrepreneurshipLayout;

    return (
        <SmartContext.Provider value={{ state, dispatch }}>
            <LayoutComponent> {!state.flags.isDataLoading && <PageBuilder data={message} />}</LayoutComponent>
        </SmartContext.Provider>
    );
};

export default Entrepreneurship;
